import { Chapter, SectionTitle, Reveal } from "./Reveal";
import { IMAGES } from "@/data/content";

const Concept = () => (
  <section id="concept" data-testid="concept-section" className="relative py-24 sm:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-7">
        <Chapter number="01" title="La Cucina" />
        <SectionTitle>
          Qui la carne non passa
          <br />
          <span className="italic text-[#C5A059]">solo dalla griglia.</span>
        </SectionTitle>
        <Reveal delay={0.15}>
          <p data-testid="concept-text" className="mt-8 text-base sm:text-lg text-[#C5BCAD] leading-relaxed max-w-xl">
            La facciamo in tartare. La cuociamo a bassa temperatura per ore, quando
            il taglio lo chiede. La mettiamo sulla griglia quando è quello che ci
            vuole. Ogni taglio ha la sua cottura e noi le facciamo tutte — è il
            motivo per cui il menù è più lungo di quello di una griglieria.
          </p>
          <p className="mt-5 text-base sm:text-lg text-[#C5BCAD] leading-relaxed max-w-xl">
            Poi c'è la Maremma. L'antipasto di selvaggina. La millefoglie di
            melanzane. I pici con cacio, pepe e tartufo. Lo stracotto di guancia.
            I dolci fatti in casa e la Pavlova.
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <blockquote className="mt-10 pl-6 border-l-2 border-[#7A1C2E] font-display italic text-xl sm:text-2xl text-[#F7F4EE]/90 leading-snug max-w-xl">
            "Sono i piatti che la gente ci nomina quando torna. Non li abbiamo scelti noi: li hanno scelti loro."
          </blockquote>
        </Reveal>
      </div>

      <div className="lg:col-span-5 relative">
        <Reveal delay={0.2} className="relative">
          <div className="absolute -inset-3 border border-[#C5A059]/25 translate-x-4 translate-y-4 pointer-events-none" />
          <div className="overflow-hidden">
            <img
              src={IMAGES.concept}
              alt="Taglio di carne d'autore al buio, luce calda"
              loading="lazy"
              className="w-full aspect-[4/5] object-cover hover:scale-105 transition-transform duration-[1.4s] ease-out"
            />
          </div>
          <span className="absolute bottom-5 left-5 text-[10px] uppercase tracking-[0.3em] text-[#C5A059] bg-[#0D0C0B]/70 backdrop-blur px-3 py-1.5">
            Frollatura · Brace · Vino
          </span>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Concept;
